import { AlertCircleIcon } from 'lucide-react'

import { ProcessDocumentButton, useDocument } from '@/modules/documents'

export const DocumentFailed = () => {
  const document = useDocument()
  if (!document) return null

  return (
    <div
      role="alert"
      className="flex flex-1 self-start flex-col items-center justify-center gap-4 rounded-lg border border-red-200 bg-white py-24 text-center"
    >
      <div className="rounded-full bg-red-50 p-4">
        <AlertCircleIcon className="size-8 text-red-500" />
      </div>
      <div className="space-y-1.5">
        <h3 className="text-lg font-semibold">Processing failed</h3>
        <p className="text-sm text-muted-foreground">
          An error occurred while processing your document.
        </p>
      </div>
      <ProcessDocumentButton>Retry processing</ProcessDocumentButton>
    </div>
  )
}
